import { FC } from 'react';
import Button from '../components/ui/Button';
import ArrowsLine from '../assets/icons/ArrowsLine';
import { setFirstLogin } from '../api/user';
import { useMutation, useQueryClient } from '@tanstack/react-query';

const SplashPage: FC = () => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation({
    mutationFn: setFirstLogin,
    onError: (error) => alert(`Error: ${error.message}`),
    onSuccess: async () =>
      await queryClient.invalidateQueries({ queryKey: ['user'] }),
  });

  return (
    <div className='relative flex min-h-screen w-full flex-col overflow-hidden bg-[#000000]'>
      <div className='flex items-center justify-center'>
        <video
          src='/images/splash_m.mp4'
          autoPlay
          loop
          muted
          playsInline
          className='object-contain'
        />
      </div>

      <div
        className={`
          flex w-full flex-1 flex-col justify-center gap-3 px-11 text-4xl font-extralight text-white
        `}
      >
        <div>monetise your</div>

        <div className='font-extrabold'>digital behaviour,</div>

        <div className='flex items-center gap-2'>
          <div>enjoy your</div>

          <div className='font-extrabold'>life</div>
        </div>

        <Button
          onClick={mutate}
          variant='solid'
          iconBack={<ArrowsLine color='currentColor' />}
          className='mb-3 mt-3 w-3/5'
        >
          GET STARTED
        </Button>
      </div>
    </div>
  );
};

export default SplashPage;
